<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

defineProps<{
    label?: string;
    selected?: boolean;
    disabled?: boolean;
  }>();

const emit = defineEmits(['click']);

function handleClick() {
  emit('click');
}
</script>

<template>
    <div
      class="rounded-xl p-4 border text-center font-semibold transition-all duration-300 cursor-pointer select-none"
      :class="[
        selected && !disabled
          ? 'border-green-400 bg-green-400/10 text-green-400'
          : disabled
          ? 'border-red-400 bg-red-400/10 text-red-400 opacity-70'
          : 'border-[#333] bg-[#1A1A1A] text-white hover:border-[#C59C2F]',
      ]"
      @click="handleClick"
    >
      <slot>{{ label }}</slot>
    </div>
  </template>

  <style scoped>
  div:hover {
    transform: scale(1.02);
  }
  </style>
